import React from "react";

/**
 * Thin scrollbar wrapper for any scrollable container.
 *
 * The style emits a single <style> block on first mount. Subsequent mounts re-emit
 * the same CSS — browsers deduplicate identical rules so this is fine and keeps the
 * component self-contained without needing a one-time setup step in App.js.
 *
 * Usage:
 *   <ThinScroll className="overflow-x-auto">
 *     <table>...</table>
 *   </ThinScroll>
 *
 * Pass `as` to render a different element (e.g. ul, section).
 */
const STYLE = `
.ip-thin-scroll::-webkit-scrollbar { width: 8px; height: 8px; }
.ip-thin-scroll::-webkit-scrollbar-track { background: transparent; }
.ip-thin-scroll::-webkit-scrollbar-thumb {
  background-color: rgba(148, 163, 184, 0.35);
  border-radius: 9999px;
}
.ip-thin-scroll::-webkit-scrollbar-thumb:hover { background-color: #32B1FF; }
.dark .ip-thin-scroll::-webkit-scrollbar-thumb { background-color: rgba(75, 85, 99, 0.6); }
.dark .ip-thin-scroll::-webkit-scrollbar-thumb:hover { background-color: #32B1FF; }
.ip-thin-scroll { scrollbar-width: thin; scrollbar-color: rgba(148, 163, 184, 0.35) transparent; }
.dark .ip-thin-scroll { scrollbar-color: rgba(75, 85, 99, 0.6) transparent; }
`;

const ThinScroll = React.forwardRef(function ThinScroll(
  { as: Tag = "div", className = "", children, ...rest },
  ref,
) {
  return (
    <>
      <style>{STYLE}</style>
      <Tag ref={ref} className={`ip-thin-scroll ${className}`} {...rest}>
        {children}
      </Tag>
    </>
  );
});

export default ThinScroll;
